import React, { Fragment, useRef } from 'react'

import { isOutsideIframe, getLogOutUrl } from '../../utils/auth'

const OAuthIframe = () => {
  const iframeRef = useRef(null)

  const checkForLogout = () => {
    if (iframeRef.current.src === getLogOutUrl()) {
      window.location.href = '/login'
    }
  }

  return (
    <Fragment>
      {isOutsideIframe() && (
        <iframe
          height="0"
          id="root-iframe"
          onLoad={checkForLogout}
          ref={iframeRef}
          style={{ display: 'none' }}
          title="root-iframe"
          width="0"
        />
      )}
    </Fragment>
  )
}

export default OAuthIframe
